import {Directive} from '@angular/core';

/**
 * card2 — subtle framed panel style: rounded corners, light border, faint surface background, compact padding.
 * Use as an attribute: `<div card2>…</div>`. Any extra classes on the element are merged with these.
 */
@Directive({
  selector: '[card2]',
  host: {
    class: 'rounded-lg border border-primary-50 bg-[var(--p-surface-50)] px-3 py-3',
  },
})
export class Card2Directive {
}
